<template>
  <div class="mt-6 vetster-prose">
    <template v-if="articleUrl">
      <a
        :href="articleUrl"
        :aria-label="articleName"
        rel="noopener noreferrer nofollow"
        target="_blank"
      >
        {{ articleName }}
      </a>
    </template>
    <template v-else>
      <span>{{ articleName }}</span>
    </template>
    <div class="text-neutral-600 text-base">
      <span>{{ authorCredit }}</span>
      <span>-</span>
      <span class="italic">
        <template v-if="articleAgency">
          <span>From {{ articleAgency }}</span>
          <span>Writing for {{ articlePublication }}</span>
        </template>
        <template v-else>
          <span>Writing For {{ articlePublication }}</span>
        </template>
      </span>
    </div>
    <div
      v-if="description"
      class="mt-4 lg:mt-2 text-base text-neutral-900"
    >
      {{ description }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'VetsterReference',

  props: {
    articleUrl: {
      type: String,
      default: '',
    },
    articleName: {
      type: String,
      default: '',
    },
    authorCredit: {
      type: String,
      default: '',
    },
    articleAgency: {
      type: String,
      default: '',
    },
    articlePublication: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
};
</script>
